<template lang="pug">
.v-grid-image.grid-image.main-page-section(v-if="data")
	.container
		.grid-image__head(v-if="data.title || data.desc")
			h3.grid-image__head-title(v-if="data.title") {{ data.title }}
			.grid-image__head-desc(v-if="data.description") {{data.description}}
			v-main-section-header(
				v-if="data.header"
				:data="data.header"
				@navigation="setNavigation")
		.grid-image__items(v-if="data.items && data.items.length && data.mode === 'grid'")
			template(v-for="(item, index) in data.items" :key="index" )
				.grid-image__item
					img.grid-image__item-img(:src="item.src" loading="lazy" :alt="item.alt")
		.grid-image__rows(v-if="data.items && data.items.length && data.mode === 'rows'")
			template(v-for="(item, index) in data.items" :key="index" )
				.grid-image__row
					img.grid-image__row-img(:src="item.src" loading="lazy" :alt="item.alt")
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';

	export default {
		mixins: [
			sourceMixin
		],
		data() {
			return {
				data: null
			}
		},
		methods: {
			dataSet(data) {
				this.data = data;
			}
		}
	}
</script>